'use client';

import { Dispatch, type ReactNode, SetStateAction, createContext, useContext, useState } from 'react';

export type GeneralStoreApi = {
    vehicleType: number;
    setVehicleType: Dispatch<SetStateAction<number>>;
};

export const GeneralStoreContext = createContext<GeneralStoreApi | undefined>(undefined);

export interface GeneralStoreProviderProps {
    children: ReactNode;
    vehicleType: number;
}

export const GeneralStoreProvider = ({ children, vehicleType }: GeneralStoreProviderProps) => {
    const [stateVehicleType, setVehicleType] = useState(vehicleType ?? 0);
    return (
        <GeneralStoreContext.Provider value={{ vehicleType: stateVehicleType, setVehicleType }}>
            {children}
        </GeneralStoreContext.Provider>
    );
};

export const useGeneralStore = (): GeneralStoreApi => {
    const generalStoreContext = useContext(GeneralStoreContext);

    if (!generalStoreContext) {
        throw new Error(`useFilterStore must be used within GeneralStoreProvider`);
    }

    return generalStoreContext;
};